import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import MaintenanceEntryPage from 'src/components/maintenance/MaintenanceEntryPage';
import { MAINTENANCE_ANCHORS } from 'src/constants/maintenance';
import FeaturesContext from 'src/context/FeaturesContext';
import { usePrinter, usePrinterType } from 'src/hooks/services/usePrinter';
import useQueryParams from 'src/hooks/useQueryParams';
import { FEATURES, isFeatureEnabled } from 'src/utils/features';
import userPropType from 'src/utils/user-prop-type';

const anchor = MAINTENANCE_ANCHORS.printer;

/**
 * Printer maintenance entry page — resolves the printer + its type through the
 * printer resource hooks and defers the loading / not-found gates and the
 * operator flow to the shared MaintenanceEntryPage.
 */
const PrinterMaintenancePage = ({ user }) => {
  const { uuid } = useParams();
  const { event: initialEventUuid } = useQueryParams();
  const { features } = useContext(FeaturesContext);
  const isEnabled = isFeatureEnabled(features, FEATURES.EQUIPMENT_MAINTENANCE);

  const instanceQuery = usePrinter(uuid, { enabled: isEnabled });
  const typeUri = instanceQuery.data?.[anchor.typeUriField];
  const typeQuery = usePrinterType(typeUri, { enabled: isEnabled && Boolean(typeUri) });

  return (
    <MaintenanceEntryPage
      user={user}
      uuid={uuid}
      anchor={anchor}
      isEnabled={isEnabled}
      instanceQuery={instanceQuery}
      typeQuery={typeQuery}
      initialEventUuid={initialEventUuid}
    />
  );
};

PrinterMaintenancePage.propTypes = {
  user: userPropType,
};

PrinterMaintenancePage.defaultProps = {
  user: null,
};

export default PrinterMaintenancePage;
